import { Card, CardContent } from '@/components/ui/card'
import { UserPlus, Globe, MessageSquare } from 'lucide-react'

export default function BrowserUseView() {
  return (
    <div className="max-w-2xl mx-auto">
      <Card>
        <CardContent className="p-6 space-y-6">
          <p className="text-sm text-muted-foreground">
            Seu agente pode usar qualquer ferramenta pelo navegador, como se fosse um colaborador da sua equipe. Siga os passos abaixo:
          </p>

          <div className="flex gap-4 items-start">
            <div className="shrink-0 rounded-lg bg-primary/10 p-2">
              <UserPlus className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h4 className="font-medium text-foreground">1. Convide o agente</h4>
              <p className="text-sm text-muted-foreground mt-1">
                Use o e-mail do agente para convidá-lo na ferramenta que você quer integrar, da mesma forma que convidaria um novo membro para o seu time.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start">
            <div className="shrink-0 rounded-lg bg-primary/10 p-2">
              <Globe className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h4 className="font-medium text-foreground">2. O agente aceita o convite</h4>
              <p className="text-sm text-muted-foreground mt-1">
                O agente vai receber o convite no e-mail dele e aceitar automaticamente. Ele terá acesso à ferramenta pelo navegador.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start">
            <div className="shrink-0 rounded-lg bg-primary/10 p-2">
              <MessageSquare className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h4 className="font-medium text-foreground">3. Instrua o agente</h4>
              <p className="text-sm text-muted-foreground mt-1">
                Diga ao agente o que ele deve fazer na ferramenta. Ele vai navegar, preencher formulários e executar tarefas como uma pessoa faria.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
